export default __webpack_public_path__ + "static/media/logo.ecbb8c47.svg";